// import media files
import BootstrapPath from 'assets/images/path/path-bootstrap.svg';
import JavascriptPath from 'assets/images/path/path-javascript.svg';
import AngularPath from 'assets/images/path/path-angular.svg';
import CSSPath from 'assets/images/path/path-css.svg';
import GatsbyPath from 'assets/images/path/path-gatsby.svg';
import ReactPath from 'assets/images/path/path-react.svg';
import GraphqlPath from 'assets/images/path/path-graphql.svg';
import VuejsPath from 'assets/images/path/path-vue-js.svg';
import NodejsPath from 'assets/images/path/path-nodejs.svg';
import PythonPath from 'assets/images/path/path-python.svg';
import GruntPath from 'assets/images/path/path-grunt.svg';
import SassPath from 'assets/images/path/path-sass.svg';
import HtmlPath from 'assets/images/path/path-html.svg';
import SketchPath from 'assets/images/path/path-sketch.svg';
import InvisionPath from 'assets/images/path/path-invision.svg';
import InvisionStudioPath from 'assets/images/path/path-invision-studio.svg';
import FigmaLogPath from 'assets/images/path/path-figma-log.svg';
import AdobeXDPath from 'assets/images/path/path-adobe-xd.svg';
import IllustratorPath from 'assets/images/path/path-illustrator.svg';

export const CoursePathData = [
	{
		id: 1,
		category: 'Development',
		logo: BootstrapPath,
		title: 'Bootstrap',
		courses: 42,
		hours: 110124
	},
	{
		id: 2,
		category: 'Program',
		logo: JavascriptPath,
		title: 'JavaScript Core Language',
		courses: 42,
		hours: 110124
	},
	{
		id: 3,
		category: 'Program',
		logo: AngularPath,
		title: 'AngularJS',
		courses: 42,
		hours: 110124
	},
	{
		id: 4,
		category: 'Development',
		logo: CSSPath,
		title: 'Advanced CSS course',
		courses: 42,
		hours: 110124
	},

	{
		id: 5,
		category: '',
		logo: GatsbyPath,
		title: 'GatsbyJS',
		courses: 6,
		hours: 11
	},
	{
		id: 6,
		category: '',
		logo: ReactPath,
		title: 'React',
		courses: 20,
		hours: 12
	},
	{
		id: 7,
		category: '',
		logo: GraphqlPath,
		title: 'GraphQl',
		courses: 16,
		hours: 24
	},
	{
		id: 8,
		category: '',
		logo: VuejsPath,
		title: 'Vue Js',
		courses: 12,
		hours: 17
	},
	{
		id: 9,
		category: '',
		logo: NodejsPath,
		title: 'Node js',
		courses: 8,
		hours: 17
	},
	{
		id: 10,
		category: '',
		logo: PythonPath,
		title: 'Python',
		courses: 32,
		hours: 12
	},
	{
		id: 11,
		category: '',
		logo: GruntPath,
		title: 'Grunt',
		courses: 8,
		hours: 23
	},
	{
		id: 12,
		category: '',
		logo: SassPath,
		title: 'Sass',
		courses: 6,
		hours: 43
	},
	{
		id: 13,
		category: '',
		logo: HtmlPath,
		title: 'HTML5',
		courses: 24,
		hours: 32
	},
	{
		id: 14,
		category: '',
		logo: SketchPath,
		title: 'Sketch',
		courses: 8,
		hours: 12
	},
	{
		id: 15,
		category: '',
		logo: InvisionPath,
		title: 'Invision',
		courses: 8,
		hours: 12
	},
	{
		id: 16,
		category: '',
		logo: InvisionStudioPath,
		title: 'Invision Studio',
		courses: 10,
		hours: 16
	},
	{
		id: 17,
		category: '',
		logo: FigmaLogPath,
		title: 'Figma',
		courses: 8,
		hours: 11
	},
	{
		id: 18,
		category: '',
		logo: AdobeXDPath,
		title: 'Adobe XD',
		courses: 14,
		hours: 26
	},
	{
		id: 19,
		category: '',
		logo: IllustratorPath,
		title: 'Adobe Illustrator',
		courses: 5,
		hours: 16
	}
];

export default CoursePathData;
